import React from "react";
import classNames from "classnames";
import { Popover } from "@blueprintjs/core";
import DefaultMenu from "components/ThreeDotsMenu/Components/DefaultMenu";
import DefaultThreeDotsMenuItem from "components/ThreeDotsMenu/Components/DefaultThreeDotsMenuItem";
import * as styles from "./styles.module.scss";
import * as plotlyStyles from "shared/plotly/styles.module.scss";
const GraphElementGraphActionMenu = ({ isOpen, menuItems, onSetIsOpen, leftOffset }) => {
    if (!menuItems?.length) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: styles.actionMenu, style: { left: leftOffset - 20 } },
            React.createElement(Popover, { fill: true, minimal: true, placement: "right-start", isOpen: isOpen, className: styles.popoverRoot, popoverClassName: styles.popover, content: React.createElement(DefaultMenu, { items: menuItems.map((item, index) => (React.createElement(DefaultThreeDotsMenuItem, { key: index, closeMenuOnClick: () => onSetIsOpen(false), ...item }))) }), onInteraction: (nextOpenState) => isOpen && onSetIsOpen(nextOpenState), modifiers: {
                    preventOverflow: {
                        enabled: true,
                        fn: (data) => {
                            const popperInstance = data?.instance?.state?.attributes?.popper;
                            const popperInstanceIsHidden = popperInstance && popperInstance["data-popper-reference-hidden"];
                            if (popperInstanceIsHidden) {
                                onSetIsOpen(false);
                            }
                        },
                    },
                    offset: { options: { offset: [0, 8] }, enabled: true },
                } },
                React.createElement(React.Fragment, null))),
        React.createElement("div", { className: classNames(plotlyStyles.actionMenuOverlay, { [plotlyStyles.visible]: isOpen }) })));
};
export default GraphElementGraphActionMenu;
